import { axios } from "../../utils/axiosBase";
import { FETCH_PACKAGE_DETAIL, LOAD_PACKAGE_DETAIL } from "./types";

const fetchPackageDetail =
  (currentLang, userId, package_urlseo, pronta_consegna_id = null, history) =>
  async (dispatch, getState) => {
    const payload = {
      currentLang: currentLang,
      userId: userId,
    };

    // chiamo web service
    let response;
    response = await axios.post(
      `api/packagedetail/${package_urlseo}/`,
      payload,
      {
        withCredentials: true,
      }
    );

    dispatch({
      type: FETCH_PACKAGE_DETAIL,
      payload: response.data,
    });
  };

const loadPackageDetail =
  (packageLoaded, history) => async (dispatch, getState) => {
    dispatch({
      type: LOAD_PACKAGE_DETAIL,
      payload: {
        packageLoaded,
      },
    });
  };

export default {
  fetchPackageDetail,
  loadPackageDetail,
};
